module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallH.svg
// module id = 261
// module chunks = 0